<template>
  <div class="dropdown">
    <div class="dropdown-body">
      <button 
        :disabled="disabled"
        type="button"
        @click.stop="onDropdownToggle"
        class="btn btn-secondary dropdown-toggle waves-effect"
      >
        <span class="t-dropdown-value">{{ selectedLabel }}</span> <span class="caret"></span>
      </button>
      <ul
        class="dropdown-menu"
        role="menu"
        v-if="!disabled && isOpened"
      >
        <li
          v-for="opt of options"
          :class="{'active': isActive(opt) && !disabled, 'disabled': disabled}"
          class="t-dropdown-item"
        >
          <a 
            href="#" 
            @click.prevent.stop="onChange(opt)"
           :class="`t-${opt.label.replace(/\s/g, '-').toLowerCase()}`"
          >
            {{ opt.label }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual';

export default {
  name: 'Dropdown',
  props: {
    options: Array,
    value: String,
    defaultValue: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  created() {
    document.body.addEventListener('click', this.hide);
  },

  destroyed() {
    document.body.removeEventListener('click', this.hide);
  },

  data() {
    return {
      isOpened: false,
    };
  },
  computed: {
    actualValue() {
      return this.value || this.defaultValue;
    },

    selectedLabel() {
      const selected = this.options.find(o => isEqual(o.value, this.actualValue));
      return selected ? selected.label : 'Select one';
    },
  },
  methods: {
    isActive(opt) {
      return this.actualValue === opt.value ? 'active' : '';
    },

    onDropdownToggle() {
      this.isOpened = !this.isOpened;
    },

    hide() {
      this.isOpened = false;
    },

    onChange(opt) {
      if (this.disabled) {
        return;
      }
      if (!this.isActive(opt)) {
        this.$emit('selected', opt.value);
      }
      this.hide();
    },
  },
};
</script>
<style scoped>
.wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
}
.dropdown-menu {
  display: block;
  padding: 4px 0;
  animation: dropdownOpen 0.3s ease-out;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26);
  max-height: 300px;
  overflow: auto;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  float: left;
  min-width: 160px;
  margin: 2px 0 0;
  font-size: 14px;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 4px;
}

.dropdown-menu .t-dropdown-item {
  font-size: 14px;
  text-align: left;
  list-style: none;
}

.dropdown-menu > li.active > a {
  color: #fff;
  text-decoration: none;
  background-color: #337ab7;
}

.dropdown-menu > li:hover {
  color: #262626;
  text-decoration: none;
  background-color: #f5f5f5;
}

.dropdown-menu > li > a {
  padding: 6px 20px;
  display: block;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/Dropdown.vue